export default function (url) {
  const cdn = window.appConfig.cdnUrl;
  if (url === null) {
    return url
  }
  if (url.includes('hungryhub.com')) {
    let split = url.split('hungryhub.com');
    return cdn + split[1];
  }
  else if (!url.includes('http')) {
    if (url.charAt(0) == '/') {
      return cdn + url;
    }
    else {
      return `${cdn}/${url}`
    }
  }
  else {
    return url;
  }
}